module.exports = __webpack_public_path__ + "static/media/mini-spot-search-icon.6aa26787.svg";